import { Add, Download, FilterList } from "@mui/icons-material";
import Button from "@mui/material/Button";
import { defaultFilteringForEvent } from "../../../common/EntitiesManagement";
import localize from "../../../common/localize";
import FilterBox from "../../../components/common/FilterBox";
import { Box, CircularProgress } from "@mui/material";

export default function EventsFilterAndAddButton({
  handleAddBtn,
  modal,
  filterModal,
  handleFilterBtn,
  filterForEvents,
  setFilterForEvents,
  printButtonMethod,
  isPrintLoading,
  printButtonDisabled,
}) {
  return (
    <div
      className="flex gap-2 flex-wrap w-full items-center"
      style={{ overflowX: "hidden", marginLeft: "16px", paddingRight: "16px" }}
    >
      <Box className="flex gap-2 flex-wrap">
        <div>
          <button
            className="btn app_button app_general_button_data btn-sm"
            style={{ flexWrap: "nowrap" }}
            onClick={handleFilterBtn}
          >
            <span className="mr-2">{localize.filter_list}</span>
            <FilterList style={{ width: "16px", height: "16px" }} />
          </button>
        </div>
        {filterModal}
      </Box>

      <div style={{ flex: 1 }}>
        <FilterBox
          filterItemName="events_filter"
          filterData={filterForEvents}
          setFilterData={setFilterForEvents}
          defaultFiltering={defaultFilteringForEvent(true)}
          saveFilter
        />
      </div>

      <div className="order-first sm:order-last" style={{ padding: "6px" }}>
        <Box className="flex gap-2 flex-wrap">
          <Button
            size="small"
            variant="contained"
            color="success"
            className="app_general_button_data app_success_button btn-sm"
            onClick={handleAddBtn}
          >
            <span className="mr-2">{localize.add}</span>
            <Add style={{ width: "16px", height: "16px" }} />
          </Button>

          {printButtonMethod && (
            <Button
              disabled={printButtonDisabled}
              size="small"
              variant="contained"
              sx={{ backgroundColor: "#10366E" }}
              className="app_general_button_data btn-sm"
              onClick={printButtonMethod}
            >
              <span className="mr-2">{localize.export}</span>
              {!isPrintLoading ? (
                <Download />
              ) : (
                <CircularProgress style={{ width: "20px", height: "20px" }} />
              )}
            </Button>
          )}
          {modal}
        </Box>
      </div>
    </div>
  );
}
